<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      title="赠送规则"
      id-key="AutoId"
      :in-dialog="inDialog"
      :data="data"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @saved="onSaved"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="触发条件" prop="EventType" label-width="85px">
          <el-select size="mini" style="width:100%" v-model="data.EventType" placeholder="请选择触发条件">
            <el-option label="用户注册" :value="0"></el-option>
            <el-option label="消费次数" :value="1"></el-option>
            <el-option label="消费金额" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="data.EventType==1">
          <el-form-item label="消费次数达到" prop="LeastValue" label-width="110px">
            <el-input v-model="data.LeastValue" placeholder="请输入次数"></el-input>
          </el-form-item>
        </template>
        <template v-if="data.EventType==2">
          <el-form-item label="消费金额达到" prop="LeastValue" label-width="110px">
            <el-input v-model="data.LeastValue" placeholder="请输入金额"></el-input>
          </el-form-item>
        </template>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        AutoId: 0,
        CouponId: null,
        EventType: null, //事件类型 - 0:用户注册 1:消费次数 2:消费金额
        LeastValue: null, //消费次数 or 消费金额
      },
      api: require("@/api/sale/couponAuto").default,
      rules: {
        EventType: [{ required: true, message: "请选择事件类型" }],
        LeastValue: [
          { required: true, message: "不能为空" },
          { validator: this.$commonJs.validateRules.num },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onBeforeSave() {
      if (this.data.EventType == 0) {
        this.data.LeastValue = 0;
      }
      return true;
    },
    onSaved(res) {
      this.data.AutoId == res.Data;
      this.$emit("on-saved", { ...this.data });
    },
  },
};
</script>